
import { defineComponent, onMounted } from "vue";
import { MenuComponent } from "@/assets/ts/components";
import { useI18n } from "vue-i18n";

export default defineComponent({
  name: "declaration-management-export-declaration-detail",
  components: {},
  setup() {
    const { t } = useI18n();

    onMounted(() => {
      MenuComponent.reinitialization();
    });

    return {
      t,
    };
  },
});
